import { useState, useEffect } from "react";
import Logo from "../../assets/images/icons8-truck-fleet-100.png";
import { message, Select } from "antd";
import { getall_commandes, update_commande } from "../../api/commandes";
import { useNavigate } from "react-router-dom";
import "moment/locale/fr";
import moment from "moment";
import { upload_bc } from "../../api/mobile";
import { getall_facture } from "../../api/factures";
import { get_listeCamion } from "../../api/camion";
import { get_ListeChauffeur } from "../../api/chauffeur";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import Notification from '../Notification'

const {Option} = Select
const UploadImage = () => {
    const [notif, setnotif] = useState({
        message: null,
        info: null,
    });
    const [showToast, setshowToast] = useState(false);

    const [selectedCommandes, setSelectedCommandes] = useState("");
    const [files, setFiles] = useState([]);
    const [fileList, setFileList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [listeFacture, setlisteFacture] = useState([])
    const [selectedFacture, setselectedFacture] = useState({})
    const navigate = useNavigate();

    const [listeChauffeur, setlisteChauffeur] = useState([])
    const [listeCamions, setlisteCamions] = useState([])
    const [selectedChauffeur, setSelectedChauffeur] = useState()
    const [selectedCamion, setSelectedCamion] = useState()
    const [compagnie, setCompagnie] = useState("COMPAGNIE MASOANDRO");
    const [agence, setAgence] = useState("ANTANANARIVO");
    const [observation, setObservation] = useState("");

    useEffect(() => {
        fetchListeCamion()
        fetchListeChauffeurs()
        const token = localStorage.getItem('token')
        if (token) {
            fetchFacture()
        } else {
            navigate('/mobile/login')
        }
    }, []);

    const fetchListeCamion = async () => {
        const res = await get_listeCamion();
        if (res.status === "success") {
            setlisteCamions(res.data);
        }
    };

    const fetchListeChauffeurs = async () => {
        const res = await get_ListeChauffeur();
        setlisteChauffeur(res.data);
    };


    const fetchFacture = async (range = []) => {
        try {
            let start, end;
            if (range.length === 2) {
                start = moment(range[0]).format("YYYY-MM-DD HH:mm:SS");
                end = moment(range[1]).format("YYYY-MM-DD HH:mm:SS");
            } else {
                end = moment().format("YYYY-MM-DD HH:mm:SS");
                start = moment().subtract(6, "months").format("YYYY-MM-DD HH:mm:SS");
            }
            const res = await getall_facture({ start, end });
            if (res.data && Array.isArray(res.data)) {
                setlisteFacture(res.data);
            } else {
                navigate("/mobile/login");
            }
        } catch (error) {
            navigate("/mobile/login");
        } finally {
            setLoading(false);
        }
    };

    const uploadFile = async () => {
        if (!selectedFacture?.commande_id) {
            setError("Veuillez sélectionner la facture.");
            return;
        }
        if (!selectedCamion) {
            setError("Veuillez sélectionner un camion.");
            return;
        }
        if (!selectedChauffeur) {
            setError("Veuillez sélectionner un chauffeur.");
            return;
        }
        if (!fileList.length) {
            setError("Veuillez sélectionner au moins un fichier.");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            fileList.forEach((file) => {
                formData.append("files[]", file.originFileObj);
            });
            formData.append("facture_id", selectedFacture.commande_id);
            formData.append("camion_id", selectedCamion);
            formData.append("chauffeur_id", selectedChauffeur);
            formData.append("compagnie", compagnie);
            formData.append("agence", agence);
            formData.append("observation", observation);
            formData.append("user_id", localStorage.getItem('user_id'));
            await upload_bc(formData);
            message.success("Bon de commande uploadé avec succès ✅");
            setFiles([]);
            setselectedFacture({});
            setSelectedCamion(null);
            setSelectedChauffeur(null);
            const res = await update_commande(selectedCommandes)
            if (res.status === "success") {
                setnotif({
                    ...notif,
                    message: "Bon de commande envoyer  avec succés",
                    info: "success",
                });
                setshowToast(true);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                message.warning("Erreur lors de l' envoie es bons de commandes !!!");
                setnotif({
                    ...notif,
                    message: "Erreur lors de l'envoi  bon de commandes !!!",
                    info: "error",
                });
                setshowToast(true);
                setTimeout(() => {
                    setshowToast(false);
                }, 1500);
            }

        } catch (error) {
            message.error("Erreur lors de l’upload ❌");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mobile-upload-wrapper">
            <div className="mobile-upload-card">
                {/* <img src={Logo} alt="Logo" className="upload-logo" />
                <h2 className="upload-title">Uploader une facture</h2> */}

                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-group">
                    <label>Compagnie</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nom de la compagnie"
                        value={compagnie}
                        onChange={(e) => setCompagnie(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Agence</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nom de l’agence"
                        value={agence}
                        onChange={(e) => setAgence(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Référence facture</label>
                    <Select
                        showSearch
                        size="large"
                        value={selectedFacture.commande_id}
                        onChange={(value) => {
                            setselectedFacture(prev => ({
                                ...prev,
                                commande_id: value,
                            }));
                        }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {
                            listeFacture && listeFacture.map(item => {
                                return (
                                    <Option key={item.id} value={item.id}>{item.ref_facture}</Option>
                                )
                            })
                        }

                    </Select>
                </div>

                <div className="form-group">
                    <label>Camion</label>
                    <Select
                        showSearch
                        size="large"
                        placeholder="Sélectionner un camion"
                        value={selectedCamion}
                        onChange={setSelectedCamion}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {listeCamions?.map(camion => (
                            <Select.Option key={camion.id} value={camion.id}>
                                {camion.imm}
                            </Select.Option>
                        ))}
                    </Select>
                </div>

                <div className="form-group">
                    <label>Chauffeur</label>
                    <Select
                        showSearch
                        size="large"
                        placeholder="Sélectionner un chauffeur"
                        value={selectedChauffeur}
                        onChange={setSelectedChauffeur}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {listeChauffeur?.map(chauffeur => (
                            <Select.Option key={chauffeur.id} value={chauffeur.id}>
                                {chauffeur.nom} {chauffeur.prenom}
                            </Select.Option>
                        ))}
                    </Select>
                </div>

                <div className="form-group">
                    <label>Fichiers à uploader</label>

                    <Upload
                        multiple
                        fileList={fileList}
                        beforeUpload={() => false} // IMPORTANT
                        onChange={({ fileList }) => setFileList(fileList)}
                    >
                        <Button icon={<UploadOutlined />}>
                            Sélectionner les fichiers
                        </Button>
                    </Upload>
                </div>

                <div className="form-group">
                    <label>Observation</label>
                    <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Observation ou remarque"
                        value={observation}
                        onChange={(e) => setObservation(e.target.value)}
                    />
                </div>

                <button
                    className="btn btn-upload"
                    onClick={uploadFile}
                    disabled={loading}
                >
                    {loading ? "Upload..." : "Uploader"}
                </button>
            </div>

            {showToast && (
                <Notification message={notif.message} status={notif.info} />
            )}

        </div>
    );
}

export default UploadImage;
